import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title, Form } from 'components/layout'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { injectIntl, FormattedMessage } from 'react-intl'


@form({
  form: 'merge-accounts-approval-modal',
  disableHook: true
})
@injectIntl
class MergeAccountsApprovalModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    modal: PropTypes.func,
    isLoading: PropTypes.bool,
    sourceParticipantId: PropTypes.number,
    targetParticipantId: PropTypes.number,
    onApprove: PropTypes.func.isRequired
  }

  getModalDefaultMessage () {
    return 'After the award transfer, the source account that has no award will be removed. ' +
      'The participant will use login credentials from the target account. Conditions for the transfer are: ' +
      'a) source account must have only one Award level that does not exists on the target. ' +
      'b) source Award level has to be lower than the target. ' +
      'c) both participants has to be active ' +
      'd) birthdates on both accounts must be the same. ' +
      'It may take couple minutes for the award to appear on the new account after the operation. ' +
      'Do not forget to check that major activities are as they should be after the transfer.'
  }

  render () {
    const {
      modalId,
      modal,
      handleSubmit,
      sourceParticipantId,
      targetParticipantId,
      isLoading,
      onApprove
    } = this.props

    return (
      <Modal id={modalId} modal={modal} customActions>
        <Title h2 intlKey="moduleTitle.accounts_merging">
          Account Merging (moving Awards)
        </Title>
        <Form
          className="form"
          onSubmit={handleSubmit((onApprove))}
        >
          <div className="row">
            <div className="col-xs-12" style={{ marginBottom: '15px' }}>
              <FormattedMessage
                id="label.merge_account_modal_question"
                defaultMessage={this.getModalDefaultMessage()}
              />
              <br /><br />
              <p style={{ fontWeight: 'bold' }}>
                <FormattedMessage
                  id="label.merge_account_modal_question_detail"
                  defaultMessage='Are you sure want to merge {spid} with {tpid}.'
                  values={{
                    spid: sourceParticipantId,
                    tpid: targetParticipantId
                  }}
                />
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Button
                intlKey="button.dismiss"
                onClick={() => this.props.modal(null)}
                secondary
                type="button"
                style={{ marginRight: 10 }}
              >
                Dismiss
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                isLoading={isLoading ? true : undefined}
                intlKey="button.approve"
                type="submit"
              >
                Approve
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default MergeAccountsApprovalModal
